module.exports = __webpack_public_path__ + "media/images/article/2021_03-65cd9df6963671ac9df132864f7ce92e.png";